import { Injectable, inject } from '@angular/core'
import { Actions, createEffect, ofType } from '@ngrx/effects'
import { from } from 'rxjs'
import { map, switchMap } from 'rxjs/operators'
import { TriggerApiService } from 'src/api/trigger'
import { ToasterService } from 'src/shared/toaster/toaster.service'
import { catchAndLog } from 'src/shared/utils/catch-and-log'
import { loadRecipientTypes, loadRecipientTypesFailure, loadRecipientTypesSuccess } from './recipient-type.actions'

@Injectable()
export class RecipientTypeEffects {
  private actions$ = inject(Actions)
  private triggerApi = inject(TriggerApiService)
  private toaster = inject(ToasterService)


  loadRecipientTypes$ = createEffect(() => this.actions$.pipe(
    ofType(loadRecipientTypes),
    switchMap(() =>
      from(this.loadAllRecipientTypes()).pipe(
        map(recipientTypes => loadRecipientTypesSuccess({ recipientTypes })),
        catchAndLog(this.toaster, 'Unable to fetch recipient types', loadRecipientTypesFailure)))))

  private async loadAllRecipientTypes(): Promise<any[]> {
    const { data: events } = await this.triggerApi.getEventTypes()
    const groups = [...new Set(events.map(e => e.group))]
    
    const recipientTypesPromises = groups.map(group => 
      this.triggerApi.getRecipientUserTypes({ group })
        .then(({ data }) => data.map(({ label, value }) => ({ name: label, id: value })))
    )
    
    const allRecipientTypes = (await Promise.all(recipientTypesPromises)).flat()

    return allRecipientTypes;
  }
}
